// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// RxJS
import { finalize, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
// Translate
import { TranslateService } from '@ngx-translate/core';
// Auth
import { AuthNoticeService, AuthService } from '../../../../core/auth';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'kt-attorney-forgot-password',
	templateUrl: './attorney-forgot-password.component.html',
	encapsulation: ViewEncapsulation.None
})
export class AttorneyForgotPasswordComponent implements OnInit, OnDestroy {
	// Public params
	forgotPasswordForm: FormGroup;
	loading = false;
	errors: any = [];

	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	status: any;
	private returnUrl: any;
	is_submit_enabled: boolean = true;

	/**
	 * Component constructor
	 *
	 * @param authService
	 * @param authNoticeService
	 * @param translate
	 * @param router
	 * @param fb
	 * @param cdr
	 */
	constructor(
		private auth: AuthService,
		public authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private toastr: ToastrService,
		private route: ActivatedRoute,
		private titleService:Title
	) {
		this.unsubscribe = new Subject();
		this.titleService.setTitle('Debtor Education | Forgot Password');
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.initRegistrationForm();
		this.route.queryParams.subscribe(params => {
			this.returnUrl = params['returnUrl'] || '/auth/attorney/login';
		});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initRegistrationForm() {
		this.forgotPasswordForm = this.fb.group({
			email: ['', Validators.compose([
				Validators.required,
				Validators.email,
				Validators.minLength(3),
				Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			]
		});
	}

	/**
	 * Form Submit
	 */
	submit() {
		this.is_submit_enabled = true;
		const controls = this.forgotPasswordForm.controls;
		/** check form */
		if (this.forgotPasswordForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}
		this.loading = true;
		const email = controls['email'].value;
		this.auth
			.requestPassword(email,true)
			.pipe(
				tap(),
				 takeUntil(this.unsubscribe),
				 finalize(() => {
					this.loading = false;
				 	this.cdr.markForCheck();
				 })
			)
			.subscribe(
				data => {
					if (data.succeeded) {
						this.is_submit_enabled = false;
						this.loading = false;
						this.cdr.markForCheck();
						this.toastr.success("Your password has been successfully sent on your email-id.", 'Success!');
						this.router.navigateByUrl(this.returnUrl);
					 } else {
						this.is_submit_enabled = true;
					  	this.toastr.error('Email is not registered please check email address is valid or not', 'Oops!');
					}
				  },
				  error => {
					console.log("err", error)
				  }
				);
	}

	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.forgotPasswordForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result =
			control.hasError(validationType) &&
			(control.dirty || control.touched);
		return result;
	}
}
